/**
 * Please add the project custom components to this folder
 * @namespace project.components
 */
import Autocomplete from './autocomplete/Autocomplete';
import ToggleBtn from "./toggleBtn/ToggleBtn";
import DirectionsBox from './directionsBox/DirectionsBox';
import MainBox from "./mainBox/MainBox";
import BlockAutocomplete from "./blockAutocomplete/BlockAutocomplete";
import TransportModes from "./transportModes/transportModes";
import JPList from './JPList/JPList';
import JPRouteDetails from './JPRouteDetails/JPRouteDetails';
import JPTransitGeneralInfo from './JPTransitGeneralInfo/JPTransitGeneralInfo';
import JPNonTransitGeneralInfo from './JPNonTransitGeneralInfo/JPNonTransitGeneralInfo';
import JPNonTransitStepsInfo from './JPNonTransitStepsInfo/JPNonTransitStepsInfo';
import JPTransitStepsInfo from './JPTransitStepsInfo/JPTransitStepsInfo';
import HotelLocation from "./hotelLocation/HotelLocation";
import CategoriesPanel from "./categoriesPanel/CategoriesPanel"
import HotelDetailPanel from "./hotelDetailPanel/HotelDetailPanel";

let Components = {
    Autocomplete: Autocomplete,
    ToggleBtn: ToggleBtn,
    DirectionsBox: DirectionsBox,
    MainBox: MainBox,
    BlockAutocomplete: BlockAutocomplete,
    JPList: JPList,
    HotelLocation: HotelLocation,
    TransportModes: TransportModes,
    JPRouteDetails: JPRouteDetails,
    JPTransitGeneralInfo: JPTransitGeneralInfo,
    JPNonTransitGeneralInfo: JPNonTransitGeneralInfo,
    JPNonTransitStepsInfo: JPNonTransitStepsInfo,
    JPTransitStepsInfo: JPTransitStepsInfo,
    CategoriesPanel: CategoriesPanel,
    HotelDetailPanel: HotelDetailPanel
};

export default Components;



// WEBPACK FOOTER //
// ./src/components/index.js